import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography, Empty, Button, Modal, Input, Form, message } from "antd";
import { getBusinessGroups } from "PlatForms/OrgLMS/Services/AdminServices/CourseListService";
import { useNavigate } from "react-router-dom";
import api from "Common/Client/Interceptor";
import API from "Common/Client/endpoint";
const { Text, Title } = Typography;
const BusinessGroupsList = () => {
  const token = localStorage.getItem("token");
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  useEffect(() => {
    fetchBusinessGroups();
  }, []);
  const fetchBusinessGroups = async () => {
    try {
      setLoading(true);
      const data = await getBusinessGroups();
      setGroups(data);
    } catch (error) {
      console.error("Error fetching business groups:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddGroup = async (values) => {
    try {
      setSubmitting(true);
        const response = await api.post(API.businessGroup.addBusinessGroupByAdmin, {
      name: values.groupName,
    });
      message.success("Business Group added successfully");
      setIsModalVisible(false);
      form.resetFields();
      fetchBusinessGroups(); // Refresh the list
    } catch (error) {
      console.error("Error adding group:", error);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <Card
      title="Business Groups"
      className="card-professional"
      loading={loading}
      extra={
        <Button type="default" onClick={() => navigate("/business-groups")}>
          Back
        </Button>
      }
    >
      <Button type="primary" onClick={() => setIsModalVisible(true)}>
        Add Business Group
      </Button>
      {/* Modal for adding new group */}
      <Modal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => form.submit()}
        title="Add Business Group"
        centered
        okText="Submit"
        confirmLoading={submitting}
      >
        <Form form={form} onFinish={handleAddGroup} layout="vertical">
          <Form.Item
            name="groupName"
            label="Business Group Name"
            rules={[{ required: true, message: "Please enter group name" }]}
          >
            <Input placeholder="Enter business group name" />
          </Form.Item>
        </Form>
      </Modal>
      <br />
      <br />
      {groups.length === 0 && !loading ? (
        <Empty description="No business groups found" />
      ) : (
        <Row gutter={[16, 16]}>
          {groups.map((group) => (
            <Col xs={24} sm={12} md={8} lg={6} key={group.id}>
              <Card hoverable onClick={()=> navigate (`/business-group-detail`,{
                state:{ businessGroupId: group.id,
                  businessGroupName:group.name
                }
              })} style={{ boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }}>
                <Title level={5} style={{ marginBottom: 16 }}>
                  {group.name}
                </Title>
                <div style={{ marginBottom: 8 }}>
                  <Text>
                    <strong>Created On:</strong> {new Date(group.createdOn).toLocaleDateString()}
                  </Text>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Card>
  );
};
export default BusinessGroupsList;
